import {
  type LoadingManager,
  type Material,
  type WebGLRenderer,
  MeshStandardMaterial,
  MeshPhysicalMaterial,
} from '@seddi/three';
import log from 'loglevel';
import { SurfaceMaterialDesc } from '../domain/materialTypes';
import { load } from './materialLoader';
import { ResourceManager } from './resourceManager';

export class MaterialsContext extends ResourceManager<MeshPhysicalMaterial> {
  readonly fallback: Material;
  readonly manager: LoadingManager;
  readonly renderer: WebGLRenderer;

  constructor(manager: LoadingManager, renderer: WebGLRenderer) {
    super();
    this.manager = manager;
    this.renderer = renderer;
    this.fallback = new MeshStandardMaterial({ color: 0xdddddd });
  }

  dispose() {
    this.fallback.dispose();
  }

  async loadAsync(desc: SurfaceMaterialDesc): Promise<MeshPhysicalMaterial | undefined> {
    if (this.find(desc.id)) {
      log.warn(`MaterialsContext.loadAsync: ${desc.id} is not new.`);
      return undefined;
    }

    const item = this.create(desc.id);
    item.status = 'loading';

    const value = await load(desc, this.manager, this.renderer);

    item.value = value;
    item.status = 'ready';

    if (this.onLoad) {
      this.onLoad(desc.id, 'Material');
    }

    return value;
  }

  forceUpdateAll() {
    for (const [, item] of this.map) {
      if (item.value) {
        item.value.needsUpdate = true;
      }
    }
  }
}
